import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'order-invoice-header',
  templateUrl: './order-invoice-header.component.html',
  styleUrls: ['./order-invoice-header.component.scss']
})
export class OrderInvoiceHeaderComponent implements OnInit {

  @Input() countryCode ;
  alignText  = 'ltr';
  constructor() {

  }

  ngOnInit(): void {
    if(this.countryCode == 'IQ'){
      this.alignText = 'rtl';
    }
  }
}
